import styled from 'styled-components';
import { Checkbox as AntCheckbox } from 'antd';

const Checkbox = styled(AntCheckbox)`
  &.ant-checkbox-wrapper {
    align-items: center;
    display: flex;
    flex-direction: ${(props) => (props.$labelLeft ? 'row-reverse' : 'row')};
    gap: 6px;
    line-height: var(--font-line-height-regular);

    .ant-checkbox {
      align-self: center;
      margin-top: 0;
    }

    span {
      padding: 0;
    }

    &.ant-checkbox-wrapper-disabled {
      cursor: default;

      .ant-checkbox {
        background-color: var(--greyscale-dark-white);
        border-color: var(--greyscale-light-grey);
      }
    }

    &.worklist-action-banner {
      .ant-checkbox-label {
        color: var(--greyscale-white);
      }
    }

    &.ai-suggested {
      .ant-checkbox-checked {
        background-color: var(--ai-grape);
        border-color: var(--ai-grape);

        &:not(.ant-checkbox-disabled):hover {
          background-color: var(--ai-grape-light);
          border-color: transparent;
        }
      }
    }
  }
`;

const CheckboxGroup = styled(AntCheckbox.Group)`
  &&.ant-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .ant-checkbox-wrapper {
      align-items: center;
      gap: 6px;
      margin: 0;

      .ant-checkbox {
        margin-top: 0;
        align-self: center;
      }

      span {
        padding: 0;
      }
    }
  }
`;

Checkbox.Group = CheckboxGroup;

export default Checkbox;
